import {computed, makeObservable, observable} from "mobx";
import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {AbstractModel} from "./abstract-model";

export interface ProcessSourceProps {
    objectId?: number;
    projectId?: number;
    name?: string;
    code?: string;
    creator?: string;
    createdAt?: Date;
    editor?: string;
    updatedAt?: Date;
}

/**
 * Prozessquelle
 */
@JsonObject()
export class ProcessSource extends AbstractModel {

    static readonly comparableAttributes: string[] = ["PROJ_ID", "PQ_NR_GK", "PQ_NAME"];
    static readonly prototypeAttributes: string[] = [
        "OBJECTID", "PROJ_ID", "PQ_NAME", "PQ_NR_GK", "CREATED_USER", "CREATED_AT", "UPDATED_USER", "UPDATED_AT"
    ];
    // field mappings
    static readonly databaseFieldNames: Map<string, string> = new Map<string, string>([
        ["objectId", "OBJECTID"],
        ["projectId", "PROJ_ID"],
        ["name", "PQ_NAME"],
        ["code", "PQ_NR_GK"],
        ["creator", "CREATED_USER"],
        ["createdAt", "CREATED_AT"],
        ["editor", "UPDATED_USER"],
        ["updatedAt", "UPDATED_AT"]
    ]);

    class = "ProcessSource";
    typeLabel = "Prozessquelle";

    /**
     * !!! use OBJECTID as GUID
     */
    @JsonProperty({name: "OBJECTID"})
        guid: string;

    /**
     * Projektschlüssel
     */
    @JsonProperty({name: "PROJ_ID"})
        projectId: number;

    /**
     * Prozessquellenname
     *
     * @example: Pfaffrüti
     */
    @JsonProperty({name: "PQ_NAME"})
        name: string;

    /**
     * Prozessquellencode
     *
     * @example: 00100R5
     */
    @JsonProperty({name: "PQ_NR_GK"})
        code: string;


    constructor(props?: ProcessSourceProps) {
        super();
        if (props) {
            Object.assign(this, props);
        }
        // make observable after setting properties to avoid 'strict' messages
        makeObservable(this, {
            objectId: observable, // do observe to reload when object is saved
            guid: observable,
            projectId: observable,
            name: observable,
            code: observable,

            isAlterable: computed,

            creator: observable,
            createdAt: observable,
            editor: observable,
            updatedAt: observable,
            isNewRecord: computed
        });
    }

    get comparableAttributes(): string[] {
        return ProcessSource.comparableAttributes;
    }

    get isAlterable(): boolean {
        return true;
    }

}

